export const landscapeWidth = 720;

// Ideally, whenever the a server call responds with success: false it should also
// send an error code of this format. This way implementation details of the server
// are hidden from the client.
export const ErrorCodes = {
  // XHR codes
  XHRError: {
    code: 100,
    message: 'There was an error sending the request. Please try again.'
  },
  XHRTimeout: {
    code: 101,
    message: 'There was a timeout when sending the request. Please try again.'
  },
  XHRAbort: {
    code: 102,
    message: 'The request was aborted. Please try again.'
  },
  XHRServer: {
    code: 103,
    message: 'The request failed on the server. Please try again'
  },
  // API codes
  Generic: {
    code: 1000,
    message: 'Something went wrong. Please try again.'
  },
  HoldItemsFailed: {
    code: 1001,
    message: 'The requested items are no longer available. Please try again.'
  },
  HoldItemsEmpty: {
    code: 1002,
    message: 'Something went wrong. Please try again.'
  }
};

// Language and Text Constants...
export const languageJson = {
	"1":{ //English
		"check_out_js": {
			"promo_code": {
				"promo_code_title": "PROMO CODE",
				"promo_code_content": "The promo code you applied seems to be saving you less money than what you are already saving!",
				"promo_code_accept": "OKAY, GREAT!",
				"promo_code_accept_but_another_one": "OKAY, THANKS!"
			},
			"gift_card": {
				"gift_card_title": "GIFT CARDS",
				"gift_card_accept": "SAVE & CLOSE",
				"gift_card_label": "GIFT CARD NUMBER",

				"points_card_title": "REDEEM POINTS",
				"points_card_label": "CUSTOMER CARD NUMBER (20 DIGITS)",
				"points_login_description": "Login with an account to pay with points",
				"points_refund_warning": "Bookings made using loyalty points may be moved, but are not refundable",
				"points_google_button": "Google",
				"points_facebook_button": "Facebook",
				"points_redirect": "How do I get points? Create an account!",
				"points_failed_login_text_part_1": "Looks like you don't have an account yet!",
				"points_failed_login_text_part_2": "Please click the link below to create an account!"
			},
			"click_next": {
				"next_title": "AN ERROR OCCURRED",
				"next_content": "Unfortunately, the items you selected are no longer available. Please go back and try again.",
				"next_accept": "CONTINUE"
			},
			"input_check": {
				"checking": "Checking",
				"promo_code_applied": "Promo code applied!",
				"promo_code_found": "Promo code found!",
				"invalid_promo_code": "Invalid promo code",
				"promo_code_not_applied": "Promo code not applied",
				"no_more_uses": "No more uses available",
				"requirements_not_met": "Requirements not met"
			},
			"checkout_modal": {
				"almost": "ALMOST THERE!",
				"confirm": "Please confirm the following details are correct to proceed:",
				"location": "Booking at Ctrl V",
				"date": "on",
				"yes": "CORRECT!",
				"no": "GO BACK",
                "booking_start_time": "Booking Start Time:",
                "your_arrival_time": "Your Arrival Time:",
                "minutes_early": "(15 Minutes Early)"
			},
			"render": {
				"first_name_label": "FIRST NAME",
				"first_name_error": "Required field",
				"last_name_label": "LAST NAME",
				"last_name_error": "Required field",
				"email_label": "EMAIL",
				"email_error": "Please enter a valid email",
				"email_placeholder": "example@email.com",
				"confirm_email_label": "CONFIRM YOUR EMAIL",
				"confirm_email_error": "Emails must match",
				"confirm_email_placeholder": "example@email.com",
				"phone_label": "PHONE NUMBER",
				"phone_error": "Please enter a valid phone number",
				"phone_placeholder": "(555)-555-5555",
				"customer_number_label": "CUSTOMER NUMBER",
				"promo_label": "PROMO CODE",
				"accept_terms_text" : "I accept the",
				"terms_and_conditions": "Terms and Conditions",
				"young_children_attending_label" : "Are any guests in your group under the age of 8?",
				"young_children_attending_hover": "Children under 8 years of age may require extra attention. Informing<br/>us ahead of time allows our staff to be better prepared to provide<br/>your group with the best possible customer service experience.",
				"apply_gift_cards": "APPLY GIFT CARDS OR POINTS",
				"apply_just_points": "APPLY POINTS",
				"next_name": "PAY",
				"prev_name": "BACK"
			},
			"extraLifeGiftCardWarning": "PROMOTIONS AND GIFT CARDS ARE NOT APPLICABLE TO THE ITEMS IN YOUR CART"
		},
		"date_selection_js": {
			"close_calendar": "CLOSE CALENDAR",
			"full_calendar": "CALENDAR VIEW",
			"render": {
				"sub_header": "Welcome to Ctrl V - The World’s First Virtual Reality Arcade! Use the calendar below to book your next VR session.",
				"slogan": "Because sometimes reality just isn’t enough...",
				"next_name_true": "FACILITY",
				"next_name_false": "NEXT",
				"prev_name": "LOCATION"
			}
		},
		"location_selection_js": {
			"render": {
				"country": {
					"header": "BOOK A VR SESSION",
					"sub_header": "SELECT COUNTRY",
					"prev_name": "MAIN SITE"
				},
				"province_state": {
					"sub_header_post_true": "SELECT PROVINCE",
					"sub_header_post_false": "SELECT STATE",
					"prev_name": "BACK"
				},
				"city": {
					"sub_header": "SELECT CITY",
					"prev_name": "BACK"
				},
				"facility": {
					"sub_header": "SELECT FACILITY",
					"prev_name": "BACK"
				},
				"default": {
					"error": "An error has ocurred. Please send the Console Log to developer@ctrlv.ca"
				}
			}
		},
		"new_browser_selection_js": {
			"render": {
				"header": "THIS BROWSER IS NOT SUPPORTED.",
				"sub_header": "PLEASE TRY ANOTHER",
				"browser_container_pre": "Currently we do not support your browser.",
				"browser_container_post": "Here are a few that we recommend instead:",
				"google_chrome": "Install Google Chrome",
				"firefox": "Install Mozilla Firefox"
			}
		},
		"party_room_selection_js": {
			"click_next": {
				"overcrowding": {
					"title": "WARNING",
					"content": "The number of people attending is above the recommended capacity for the party room.  You can continue but it might be a tight fit!",
					"accept": "PROCEED",
					"cancel": "CANCEL"
				},
				"no_party_selected": {
					"title": "No Party Room?",
					"content": "Whoa! It appears you haven't added the Party Room to your cart!  Are you sure you want to proceed without it?",
					"accept": "I DON'T NEED NO PARTY ROOM!",
					"cancel": "GO BACK"
				},
				"no_minimum_stations": {
					"title": "More VR Stations?",
					"content": "Oh! It appears you have less than the minimum required stations to book a Party Room.  Are you sure you want to proceed?",
					"accept": "PROCEED",
					"cancel": "GO BACK"
				}
			},
			"render": {
				"no_party_rooms": "There are no Party Rooms available for this time slot. If you wish to book a Party Room, please reselect your time slot.",
				"next_name": "NEXT",
				"prev_name": "BACK"
			}
		},
		"pay_js": {
			"render": {
				"session_token": {
					"pay_redirect_pre": "Redirecting you to the ",
					"pay_redirect_pre_zero_true": "confirmation",
					"pay_redirect_pre_zero_false": "payment",
					"pay_redirect_pre_page": " page.",
					"pay_redirect_post": "If this page doesn't redirect, please click the ",
					"pay_redirect_post_zero_true": "Confirm",
					"pay_redirect_post_zero_false": "Pay",
					"pay_redirect_post_button": " button.",
					"next_name": "NEXT",
					"prev_name": "CHECKOUT"
				},
				"no_session_token": {
					"pay": "Something went wrong",
					"next_name": "NEXT",
					"prev_name": "CHECKOUT"
				}
			}
		},
		"sequence_selection_js": {
			"render": {
				"next_name": "NEXT",
				"prev_name": "BACK"
			}
		},
		"station_selection_js": {
			"tran_forward": {
				"title": "OOPS",
				"content": "The items you have selected are no longer available, please select new stations.",
				"accept": "OK"
			},
			"click_next": {
				"title": "NOTICE",
				"content": "You have more than one timeslot selected in your cart, is this correct?",
				"accept": "YES",
				"cancel": "CANCEL"
			},
			"render": {
				"next_name": "NEXT",
				"prev_name": "BACK"
			},
			"restrictions": {
				"title": "HEADS UP!",
				"content": "Some of the items in your cart are not eligible to be moved or refunded. Continue?",
				"unmovable_label": "Unmovable Times:",
				"no_refund_label": "Non-refundable Times:",
				"accept": "CONTINUE",
				"decline": "BACK"
			},
			"extra_life_restrictions": {
				"title": "HEADS UP!",
				"content": "Due to the charity event, items in your cart are not eligible to be moved or refunded. Continue?",
				"unmovable_label": "Unmovable Times:",
				"no_refund_label": "Non-refundable Times:",
				"accept": "CONTINUE",
				"decline": "BACK"
			}
		},
		"sub_components": {
			"bookable_item_js": {
				"props_disabled": {
					"num_remaining": {
						"true": "LOCKED",
						"false": "SOLD OUT"
					}
				},
				"props_enabled": {
					"props_selected": {
						"true": "SELECTED",
						"false": "AVAILABLE"
					}
				},
				"props_landscape": {
					"true": "REMAINING",
					"false": "LEFT"
				},
				"time_split": {
					"sub_quantity": "How Many Humans Are Playing?",
					"turns": " people will be taking turns with ",
					"headset": " VR headset",
					"not_plural": "",
					"plural": "s",
					"throughout": " throughout the session.",
					"suitable": "Each of these items is suitable for one (1) person",
					"share": "Up to two (2) people can share one (1) of these items throughout a session."
				}
			},
			"day_selector_js": {
				"render": {
					"selected": "SELECTED",
					"today": "TODAY",
					"closed": "CLOSED"
				},
				"no_dates": `No dates available for this location.\nPlease go back and select another location.\nIf you believe this is an error, please contact us via live chat!`
			},
			"item_selection_js": {
				"render": {
					"passed": "PASSED",
					"left": " LEFT",
					"sold_out": "SOLD OUT",
					"item_selection_pulse": "Please select a time to add to your booking.",
					"item_selection_empty_item": "There are no items available for this timeslot.",
					"item_selection_empty_content": "There are no items of this type available. Please continue."
				}
			},
			"price_bar_js": {
				"render": {
					"header": {
						"is_subtotal_true": "SUBTOTAL",
						"is_subtotal_false": "TOTAL",
						"you_saved": "YOU SAVED"
					},
					"accordion": {
						"is_discount_true": "",
						"is_discount_false": "EACH",
						"line_items_empty": "There are no items in your cart.",
						"subtotal": "SUBTOTAL",
						"gift_cards_total": "Redemption Total:"
					}
				}
			}
		},
		"selectors_party_room_js": {
			"generalized_items": {
				"disabled_description_pre": "Book ",
				"disabled_description_post": " VR Station(s) to unlock"
			}
		}
	},
	"3": { //Spanish
		"check_out_js": {
			"promo_code": {
				"promo_code_title": "CÓDIGO PROMOCIÓNAL",
				"promo_code_content": "El código de promoción que aplicó, parece estarle ahorrando menos dinero que lo que ya estaba ahorrando.",
				"promo_code_accept": "BUENO"
			},
			"gift_card": {
				"gift_card_title": "TARJETAS DE REGALO",
				"gift_card_accept": "SALVAR Y CERRAR",
				"gift_card_label": "TARJETA DE REGALO",
			},
			"click_next": {
				"next_title": "OCURRIÓ UN ERROR",
				"next_content": "Desafortunadamente, los items seleccionados ya no están disponibles. Por favor regrese e intente de nuevo.",
				"next_accept": "CONTINUAR"
			},
			"input_check": {
				"checking": "Revisando",
				"promo_code_applied": "Código de promoción aplicado",
				"promo_code_found": "Código de promoción localizado",
				"invalid_promo_code": "Código de promoción inválido",
				"promo_code_not_applied": "Código de promoción no aplicado",
				"no_more_uses": "No hay más usos disponibles",
				"requirements_not_met": "No se cumplen los requerimientos"
			},
			"checkout_modal": {
				"almost": "¡CASI AHÍ!",
				"confirm": "Confirme que los siguientes detalles son correctos para continuar:",
				"location": "Reserva en Ctrl V",
				"date": "el",
				"yes": "¡CORRECTA!!",
				"no": "REGRESA",
                "booking_start_time": "Hora De Inicio De La Reserva:",
                "your_arrival_time": "Su Hora De Ilegada:",
                "minutes_early": "(15 Minutos Antes)"
			},
			"render": {
				"first_name_label": "NOMBRE",
				"first_name_error": "Espacio requerido",
				"last_name_label": "APELLIDO",
				"last_name_error": "Espacio requerido",
				"email_label": "CORREO ELECTRÓNICO",
				"email_error": "Por favor digit un correo electrónico válido",
				"email_placeholder": "ejemplo@email.com",
				"confirm_email_label": "CONFIRMAR SU CORREO ELECTRÓNICO",
				"confirm_email_error": "Los correos electrónicos deben coincidir",
				"confirm_email_placeholder": "ejemplo@email.com",
				"phone_label": "NÚMERO TELEFÓNICO",
				"phone_error": "Por favor digite un número telefónico válido",
				"phone_placeholder": "5555-5555",
				"customer_number_label": "NÚMERO DE CÉDULA DEL CLIENTE",
				"promo_label": "CÓDIGO DE PROMOCIÓN",
				"apply_gift_cards": "APLICAR TARJETAS DE REGALO",
				"next_name": "PAGAR",
				"prev_name": "REGRESAR",
				"accept_terms_text" : "Acepto los",
				"terms_and_conditions": "Términos y Condiciones"
			},
			"extraLifeGiftCardWarning": "LAS PROMOCIONES Y LAS TARJETAS DE REGALO NO SON APLICABLES A LOS ARTÍCULOS EN SU CARRITO"
		},
		"date_selection_js": {
			"close_calendar": "CERRAR CALENDARIO",
			"full_calendar": "CALENDARIO COMPLETO",
			"render": {
				"sub_header": "SELECCIONAR FECHA",
				"next_name_true": "LOCAL",
				"next_name_false": "SIGUIENTE",
				"prev_name": "UBICACIÓN"
			}
		},
		"location_selection_js": {
			"render": {
				"country": {
					"header": "RESERVE UNA ESTACIÓN DE VR",
					"sub_header": "SELECCIONE PAÍS",
					"prev_name": "SITIO PRINCIPAL"
				},
				"province_state": {
					"sub_header_post_true": "SELECCIONAR PROVINCIA",
					"sub_header_post_false": "SELECCIONAR ESTADO",
					"prev_name": "REGRESAR"
				},
				"city": {
					"sub_header": "SELECCIONAR CIUDAD",
					"prev_name": "REGRESAR"
				},
				"facility": {
					"sub_header": "SELECCIONAR LOCAL",
					"prev_name": "REGRESAR"
				},
				"default": {
					"error": "Ocurrió un error.  Por favor envíe el Registro de Consola a developer@ctrlv.ca"
				}
			}
		},
		"new_browser_selection_js": {
			"render": {
				"header": "ESTE NAVEGADOR NO ESTÁ SOPORTADO.",
				"sub_header": "POR FAVOR INTENTE CON OTRO",
				"browser_container_pre": "En este momento no soportamos su navegador.",
				"browser_container_post": "Aquí hay algunos que recomendamos:",
				"google_chrome": "Instalar Google Chrome",
				"firefox": "Instalar Mozilla Firefox"
			}
		},
		"party_room_selection_js": {
			"click_next": {
				"overcrowding": {
					"title": "ADVERTENCIA",
					"content": "La cantidad de personas es mayor que la capacidad recomendada para la Sala de Fiestas. Puede continuar pero podrían estar ajustados.",
					"accept": "PROCEDER",
					"cancel": "CANCELAR"
				},
				"no_party_selected": {
					"title": "SIN SALA DE FIESTAS?",
					"content": "Ups, parece que no agregó la Sala de Fiestas en su carrito. Está seguro que quiere continuar sin incluirla?",
					"accept": "NO NECESITO UNA SALA DE FIESTA!",
					"cancel": "REGRESAR"
				},
				"no_minimum_stations": {
					"title": "MÁS ESTACIONES DE VR?",
					"content": "Oh, parece que tiene menos de la cantidad mínima de estaciones para reservar la Sala de Fiestas.  Está seguro que desea continuar?",
					"accept": "PROCEDER",
					"cancel": "REGRESAR"
				}
			},
			"render": {
				"no_party_rooms": "No hay Salas de Fiestas disponibles para este intervalo de tiempo.  Si desea reservar una Sala de Fiestas, por favor reseleccione su intervalo de tiempo.",
				"next_name": "SIGUIENTE",
				"prev_name": "REGRESAR"
			}
		},
		"pay_js": {
			"render": {
				"session_token": {
					"pay_redirect_pre": "Redireccionándolo a la ",
					"pay_redirect_pre_zero_true": "confirmación",
					"pay_redirect_pre_zero_false": "pago",
					"pay_redirect_pre_page": " página.",
					"pay_redirect_post": "Si esta página no lo redirecciona, favor hacer click en la ",
					"pay_redirect_post_zero_true": "Confirmar",
					"pay_redirect_post_zero_false": "Pagar",
					"pay_redirect_post_button": " botón.",
					"next_name": "SIGUIENTE",
					"prev_name": "CHECKOUT"
				},
				"no_session_token": {
					"pay": "Algo salió mal",
					"next_name": "SIGUIENTE",
					"prev_name": "CHECKOUT"
				}
			}
		},
		"sequence_selection_js": {
			"render": {
				"next_name": "SIGUIENTE",
				"prev_name": "REGRESAR"
			}
		},
		"station_selection_js": {
			"tran_forward": {
				"title": "UPS",
				"content": "Los items seleccionados ya no están disponibles, favor seleccionar otras estaciones.",
				"accept": "OK"
			},
			"click_next": {
				"title": "NOTAR",
				"content": "Tiene más de un intervalo de tiempo en su carrito, es esto correcto?",
				"accept": "SÍ",
				"cancel": "CANCELAR"
			},
			"render": {
				"next_name": "SIGUIENTE",
				"prev_name": "REGRESAR"
			},
			"restrictions": {
				"title": "AVISO!",
				"content": "Algunos de los artículos en su carrito no son elegibles para ser movidos o reembolsados. ¿Continuar?",
				"unmovable_label": "Tiempos inamovibles:",
				"no_refund_label": "Tiempos no reembolsables",
				"accept": "CONTINUAR",
				"decline": "ESPALDA"
			}
		},
		"sub_components": {
			"bookable_item_js": {
				"props_disabled": {
					"num_remaining": {
						"true": "BLOQUEADO",
						"false": "AGOTADO"
					}
				},
				"props_enabled": {
					"props_selected": {
						"true": "SELECCIONADO",
						"false": "DISPONIBLE"
					}
				},
				"props_landscape": {
					"true": "RESTANTE",
					"false": "RESTANTE"
				},
				"time_split": {
					"sub_quantity": "Cuántos humanos estarán jugando?",
					"turns": " la gente estará tomando turnos con ",
					"headset": " Headset de VR",
					"not_plural": "",
					"plural": "s",
					"throughout": " durante la sesión.",
					"suitable": "Cada uno de estos items es adecuado para una (1) persona",
					"share": "Hasta dos (2) personas pueden compartir uno (1) de estos items durante una sesión."
				}
			},
			"day_selector_js": {
				"render": {
					"selected": "SELECCIONADO",
					"today": "Hoy",
					"closed": "CERRADO"
				},
				"no_dates": `No hay fechas disponibles para esta ubicación.\nPor favor vuelva y seleccione otra ubicación.\nSi cree que esto es un error, contáctenos a través del chat en nuestro website.`
			},
			"item_selection_js": {
				"render": {
					"passed": "PASÍ",
					"left": " RESTANTE",
					"sold_out": "AGOTADO",
					"item_selection_pulse": "Por favor seleccione una hora para agregar a su reservación.",
					"item_selection_empty_item": "No hay items disponibles para este intervalo de tiempo.",
					"item_selection_empty_content": "No hay items de este tipo disponibles. Favor continuar."
				}
			},
			"price_bar_js": {
				"render": {
					"header": {
						"is_subtotal_true": "SUBTOTAL",
						"is_subtotal_false": "TOTAL",
						"you_saved": "USTED AHORRÓ"
					},
					"accordion": {
						"is_discount_true": "",
						"is_discount_false": "CADA UNO",
						"line_items_empty": "No hay items en su carrito.",
						"subtotal": "SUBTOTAL",
						"gift_cards_total": "Total de Tarjetas de Regalo:"
					}
				}
			}
		},
		"selectors_party_room_js": {
			"generalized_items": {
				"disabled_description_pre": "Reservar ",
				"disabled_description_post": " Estaciones de VR para desbloquear"
			}
		}
	}
}
